import Text from '@/components/ui/text/text';
import { useStyles } from '@/features/player/components/list-player/player-card/player-card-root';
import { useScaling } from '@/hooks';

export const PlayerCardDesc = ({
  children,
}: {
  children: string | string[] | number | undefined | null;
}) => {
  const styles = useStyles();
  const { isTablet } = useScaling();

  return (
    <Text
      variant={isTablet ? 'Font Inter/Subtitle/Regular 11px' : 'Font Inter/Subtitle/Regular'}
      style={styles.playerAge}>
      {children}
    </Text>
  );
};
